module.exports = "<div class=\"outer-container\">\n  <div class=\"heading\">\n    <h1 class=\"heading--no-margin\">Page not found</h1>\n  </div>\n\n  <div class=\"contents\">\n    <p>\n      Sorry, we were unable to find that content. It could have been moved, removed or marked as private.\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main